import { Alert, Flex, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import { formatExclusionAmount } from '../utils/expense-exclusion';

const ExpenseExclusionPreview = ({ preview }) => (
  <Flex vertical gap="middle">
    <Alert
      type="info"
      showIcon
      message="以下是原始费用事实，不是报表影响金额；规则重叠时，单条命中数不等于新增排除数。"
    />
    <Typography.Text>
      命中 {preview.eventCount} 条事件，原始事件金额 {formatExclusionAmount(preview.amountCent)} 元
    </Typography.Text>
    <Table
      size="small"
      rowKey={(row) =>
        JSON.stringify([row.expenseTypeLevel1, row.expenseTypeLevel2, row.expenseTypeLevel3])
      }
      dataSource={preview.groups}
      pagination={{ pageSize: 5, showSizeChanger: false }}
      columns={[
        { title: '1级费用类型', dataIndex: 'expenseTypeLevel1' },
        { title: '2级费用类型', dataIndex: 'expenseTypeLevel2' },
        { title: '3级费用类型', dataIndex: 'expenseTypeLevel3' },
        { title: '事件数', dataIndex: 'eventCount' },
        { title: '原始事件金额（元）', dataIndex: 'amountCent', render: formatExclusionAmount },
      ]}
    />
  </Flex>
);
ExpenseExclusionPreview.propTypes = {
  preview: PropTypes.shape({
    eventCount: PropTypes.number.isRequired,
    amountCent: PropTypes.string.isRequired,
    groups: PropTypes.arrayOf(
      PropTypes.shape({ eventCount: PropTypes.number, amountCent: PropTypes.string }),
    ).isRequired,
  }).isRequired,
};
export default ExpenseExclusionPreview;
